<template>
  <LinkCard :image="thumbnail" :title="$path('name', value)" :subtitle="subtitle" :to="$attrs.to" :is-list="isList" />
</template>

<script>
import LinkCard from '@/components/LinkCard'
import StatusIndicator from '@/components/StatusIndicator'

import { Currency } from '@/filters'
import getCoverThumbnail from '@/utils/getCoverThumbnail'

export default {
  props: {
    value: Object,
    theme: {
      type: String,
      enum: ['default', 'list'],
      default: 'default',
    },
  },
  computed: {
    isList() {
      return this.theme === 'list'
    },
    subtitle() {
      return Currency(this.value.sale.value, { currency: this.value.project.metadata.currency })
    },
    thumbnail() {
      const src = getCoverThumbnail(this.$path('value.media.cover') || [])
      if (!src) return

      return { src, alt: this.value.name }
    },
    badges() {
      if (this.value.isEntry) return [{ theme: 'primary', value: this.$t('unitSelectorIsEntry') }]
      return []
    },
  },
  components: {
    LinkCard,
    StatusIndicator,
  },
}
</script>
